import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Common } from '../model/common.model';

@Injectable()
export class ContactService {

  

  constructor(private http: HttpClient) {
  
  }

  getContact(company) {    
    return this.http.get(environment.APIUrl + '/DistOneAPi/GetSysCompanyDetails?company='+company, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }
  getContactSecondaryDetails() {    
    return this.http.get(environment.APIUrl + '/UserModule/getcontactusSecondDetails', { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }

  postInquiry(model) {
    return this.http.post(environment.APIUrl + '/DistOneAPi/ContactUs', model, { headers: new HttpHeaders({'Content-Type': 'application/json; charset=utf-8' })});
  }



}

